/* eslint-disable prettier/prettier */
import { language } from "../../../../language";
import {
  STEPPER,
  GRID,
  TYPOGRAPHY,
  IMAGE,
  TEXT,
  NUMBER,
  DATE,
  UPLOADDOCUMENT,
  MULTDOCSUPLOAD,
  CHECKBOX,
  CHECKBOXLIST,
  OPTIONLIST,
  DOCUMENTVIEWER,
  MINUTE,
  CNPJ,
  CPF,
  DYNAMICLIST,
  MULTIPLEUPLOADREQUIRED,
} from "../constants";

const DEFAULT_ITEMS = {
  layout: [
    {
      id: STEPPER,
      name: language.stepper,
      type: STEPPER,
      rows: 3,
      columns: 3,
      properties: [],
      items: [],
    },
    {
      id: TYPOGRAPHY,
      name: language.typography,
      type: TYPOGRAPHY,
      properties: [],
    },
    {
      id: IMAGE,
      name: language.image,
      type: IMAGE,
      properties: [
        { id: "required", value: "Favor informar o Nome do Proponente" },
        { id: "style", type: "style", value: {} },
      ],
    },
  ],

  fields: [
    {
      id: TEXT,
      name: language.textfield,
      type: TEXT,
      properties: [
        {
          id: "onBlur_field",
          type: "onBlur_field",
          value: [],
        },
        { id: "label", type: "label", value: "Text Field" },
      ],
    },
    {
      id: NUMBER,
      name: language.numberfield,
      type: NUMBER,
      properties: [
        { id: "number", value: true },
        {
          id: "thousandSeparator",
          value: "",
          text: "thousandSeparator",
          type: "text",
        },
        { id: "label", type: "label", value: "Number" },
      ],
    },
    {
      id: DATE,
      name: language.datefield,
      type: DATE,
      properties: [{ id: "label", type: "label", value: "Date" }],
    },
    {
      id: CNPJ,
      name: language.cnpjfield,
      type: CNPJ,
      properties: [{ id: "label", type: "label", value: "CNPJ" }],
    },
    {
      id: CPF,
      name: language.cpffield,
      type: CPF,
      properties: [{ id: "label", type: "label", value: "CPF" }],
    },
  ],

  components: [
    {
      id: UPLOADDOCUMENT,
      name: "Documento upload",
      type: UPLOADDOCUMENT,
      properties: [],
    },
    {
      id: CHECKBOX,
      name: language.checkbox,
      type: CHECKBOX,
      properties: [{ id: "label", type: "label", value: "checkbox" }],
    },
    {
      id: CHECKBOXLIST,
      name: language.checkboxList,
      type: CHECKBOXLIST,
      properties: [
        {
          id: "options",
          type: "options",
          value: [],
        },

        { id: "label", type: "label", value: "checkbox list" },
      ],
    },
    {
      id: OPTIONLIST,
      name: language.select,
      type: OPTIONLIST,
      properties: [
        {
          id: "options",
          type: "options",
          value: [],
        },
        { id: "label", type: "label", value: "Selecione um item" },
      ],
    },
    {
      id: MINUTE,
      name: "Minuta",
      type: MINUTE,
      properties: [
        { id: "isDefinedTemplate", type: "isDefinedTemplate", value: false },
      ],
    },
    {
      id: DYNAMICLIST,
      name: language.dynamicList,
      type: DYNAMICLIST,
      rows: 1,
      columns: 4,
      properties: [],
      items: [],
    },
    {
      id: MULTDOCSUPLOAD,
      name: language.multDocsUpload,
      type: MULTDOCSUPLOAD,
      properties: [],
    },
    {
      id: DOCUMENTVIEWER,
      name: language.viewDocument,
      type: DOCUMENTVIEWER,
      properties: [
        { id: "label", type: "label", value: "Visualizar de Documento" },
      ],
    },
    {
      id: MULTIPLEUPLOADREQUIRED,
      name: language.multipleUploadRequired || "Upload Múltiplo Obrigatório",
      type: MULTIPLEUPLOADREQUIRED,
      properties: [
        { id: "label", type: "label", value: "Upload Múltiplo Obrigatório" },
        { id: "apiUrl", type: "apiUrl", value: "" },
        { id: "documentOptions", type: "api", value: [] },
      ],
    },
  ],
};

export default DEFAULT_ITEMS;
